import React,{useState,useEffect} from 'react'
import NavBar from '../components/NavBar'
import Sider from '../components/Sider'
import Item from '../components/Item'
import {Button,Dialog,Alert, Icon } from "@blueprintjs/core";
import db from '../firebase/config'
import { useAuthState } from 'react-firebase-hooks/auth';
import {getAuth} from 'firebase/auth'
import {setDoc, doc, collection, onSnapshot, where, query,limit,orderBy} from 'firebase/firestore'
import SharedCard from '../components/SharedCard'
import Voicestacks from '../components/Voicestacks'
import { getMessaging, getToken, } from "firebase/messaging";


const uniqueId = require('react-unique-nums')
var moment = require('moment')
moment.utc().format();
const auth = getAuth()

function Home() {

    const [data,setData] = useState(null)
    const [visible,setVisible] = useState(false)
    const [selected,setSelected] =useState('#30404D')
    const [label,setLabel] = useState("")
    const [disabled,setDisabled] = useState(true)
    const [show,setShow] = useState(false)
    const [items,setItems] = useState([])
    const [user] = useAuthState(auth)
    const [sharedItems,setSharedItems] = useState([])
    const [initial,setInitial] = useState(30);
    const [open,setOpen] = useState(false)
    const keypair = "BC7XBBz4v2bfxYIjnslpwnGAU7uT8BNojHwglVKKbOAmSuSwL79WKEPXOivZQ9FrM1LW7eYu6Kpyckpyo9KBsfE"

    const getData = (data) => {
           setData(data);
            getItems(data.docId)
    }

    const addItem = async () =>{
          let item_id = uniqueId()
          let timeStamp = moment.utc()
          const docRef = doc(collection(db, "items"));

          await setDoc(docRef,{
                 id:item_id,
                 title:label,
                 label_id:data.docId,
                 timeStamp:timeStamp._d,
                 shared:false
           });

           await setVisible(false);
           await setLabel("")
           await setShow(true)
    }

    useEffect(()=>{
        if(label === "") {setDisabled(true)} else setDisabled(false)
    },[label])

         const getItems = async(docId)=>{
             const itemQuery = query(
                    collection(db, "items"),
                    where("label_id","==",docId),
             )

             await onSnapshot(itemQuery,(snapshot) =>{
                let resArry = []
                if(snapshot.empty) {console.log("empty snapshot")}
                snapshot.forEach(doc =>{
                 resArry.push({
                    id:doc.data().id,
                    title:doc.data().title,
                    label_id:doc.data().label_id,
                    itemDocId:doc.id,
                    timeStamp:doc.data().timeStamp,
                    shared:doc.data().shared,
                    });
                })
                setItems(resArry)
            })
         }

    useEffect(() => {
        const unSubscribe = async () => {
            const queryRef = query(
                 collection(db, "items"),
                 where("shared","==",true),
                 limit(initial),
                 orderBy("timeStamp","desc")
            );

            await onSnapshot(queryRef,(snapshot) =>{
                let resArry = []
                if(snapshot.empty) {console.log("empty snapshot")}
                snapshot.forEach(doc =>{
                 resArry.push({
                    id:doc.data().id,
                    title:doc.data().title,
                    label_id:doc.data().label_id,
                    itemDocId:doc.id,
                    owner:doc.data().owner,
                    owner_name:doc.data().owner_name,
                    owner_photo:doc.data().owner_photo,
                    timeStamp:doc.data().timeStamp
                    });
                })
                setSharedItems(resArry)
            })

        }
        unSubscribe();
        return()=>unSubscribe();
    },[])

    const setDataNull = ()=>{
         setData(null)
    }

    useEffect(() => {
        const messaging = getMessaging();
            getToken(messaging, { vapidKey: keypair }).then((currentToken) => {
             if (currentToken) {
                    //check if token exist in the database
                    let checkQuery = query(
                          collection(db, "tokens"),
                          where("token","==",currentToken),
                            )
                         onSnapshot(checkQuery,(snapshot) =>{
                            if(snapshot.empty){
                                //add token to collection
                                const docRef = doc(collection(db, "tokens"));
                                setDoc(docRef,{
                                    id:currentToken,
                                    token:currentToken,
                                    owner:user.email,
                                    owner_name:user.displayName,
                                    owner_face:user.photoURL
                                })

                            } else {/*do nothing*/}
                        })

                } else {
                        console.log('No registration token available. Request permission to generate one.');
                }
                }).catch((err) => {
              console.log('An error occurred while retrieving token. ', err);
            });

    },[])
    
    return (
        <div>
            <NavBar  info ={user} setDataNull={setDataNull}/>
                <div id="main-wrapper">
                    <div id="sider">
                        <Sider  childData={getData} setDataNull={setDataNull}/>
                    </div>
                      {data === null ? 
                        <div  id="main-shared">   
                            <h1 style={{padding:12,color:'#ecf1f5'}}>Shared items</h1>
                            <h3 id="h3" style={{marginTop:-30}}>Shared items will appear here</h3>
                            <div id="voice-container">
                                             <Voicestacks />
                                        </div>

                               {sharedItems.length <= 0 ? 
                                    <div /> : 
                                        <div>


                                            {sharedItems.map(item=>(
                                                <SharedCard info={item}  key={item.id}/>
                                            ))}
                                            <Button onClick={()=>setInitial(prev=>prev + 20)} id="just-center">more</Button>
                                            </div>}
                        </div> : 
                          <div id="section">
                              
                              <div id="item">
                                <h2 id="h1" style={{
                                             borderBottomStyle:'solid',
                                             borderBottomColor:data.color,
                                             borderBottomWidth:10,
                                         }}>{data.name}</h2>
                                    <h4 id="h4">Items [{items.length}] 
                                    <Button icon="add" id="fab" size={40} onClick={()=>setVisible(prev=>!prev)} >add new item</Button>
                                           
                                            </h4>
                                          {items.length <= 0 ? <div>
                                            <Icon icon="tag"  size={80} color={data.color} style={{marginLeft:'45%',marginTop:40}}/>
                                                <h3  style={{textAlign: 'center',color:'#ecf1f5'}}>No, any item yet</h3>
                                                    <p style={{textAlign: 'center',color:'#ecf1f5'}}>Click " + add new item" to create item"</p>
                                          </div> : 
                                            <div>
                                                {items.map(item => (
                                                    <Item  info={item} key={item.id}/>
                                                ))}
                                                 
                                            </div>
                                            }
                                        </div>
                          </div>
                      }
                </div>


                <Dialog isOpen={visible} style={{backgroundColor:"#30404D"}}>
                <h3 style={{paddingLeft:20,color:'#ecf1f5',fontSize:24}}>Add new item</h3>
                      <p style={{paddingLeft:20,marginTop:-10,color:'#ecf1f5'}}>Item can be anything that you write </p>
                         <textarea placeholder="Write  item" id="input" 
                         value={label}
                         onChange={e=>{setLabel(e.target.value)}} />


                     <div style={{flexDirection:'row',alignSelf:'flex-end',marginLeft:-10}}>
                     <button id="ok" style={{opacity:0.6}} onClick={()=>setVisible(prev=>!prev)}>Cancel</button>
                        <button id="ok" onClick={()=>addItem()} disabled={disabled}>Create</button>
                     </div>
                </Dialog>

                <Alert isOpen={show} onClose={()=>setShow(prev=>!prev)}>
                    <p>New item added successfully</p>
                </Alert>

                <Dialog isOpen={open} style={{backgroundColor:"#30404D"}}
                    canOutsideClickClose={true} onClose={()=>setOpen(prev=>!prev)}>
                       <input type="file" id="file" />
                </Dialog>

               
        </div>
    )
}

export default Home
